/**
 * Created by jv on 22/08/2017.
 */
const utils = require("Sources/utils/utils");

let HistoryController = {};

((HistoryController) => {
  let history = window.history;

  HistoryController.currentState = function () {
    if (utils.isNotNull(history)) {
      return history.state;
    }
  };

  HistoryController.back = function () {
    if (utils.isNotNull(history)) {
      history.back();
    }
  };

  HistoryController.forward = function () {
    if (utils.isNotNull(history)) {
      history.forward();
    }
  };

  HistoryController.go = function (index) {
    if (utils.isNotNull(history)) {
      history.go(index);
    }
  };

  HistoryController.pushState = function (stateObj, title, url) {
    if (utils.isNotNull(history)) {
      history.pushState(stateObj, title, url);
    }
  };

  HistoryController.replaceState = function (stateObj, title, url) {
    if (utils.isNotNull(history)) {
      history.replaceState(stateObj, title, url);
    }
  };
})(HistoryController);

module.exports = HistoryController;



// WEBPACK FOOTER //
// ./app/js/controllers/history-controller.js